import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import './Proxy.css';
// import './AllowedUrls/style.css';
import ModalUrl from './AllowedUrls/ModalUrl';



function AllowedUrls() {
  const [urls, setUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [editUrl, setEditUrl] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  // Buscar URLs
  const fetchUrls = async () => {
    setLoading(true);
    setError(null);
    const { data, error } = await supabase.from('permitted_urls').select('id, url, description');
    if (error) {
      setError('Erro ao buscar URLs: ' + error.message);
      setUrls([]);
    } else {
      setUrls(data || []);
    }
    setLoading(false);
  };

  useEffect(() => { fetchUrls(); }, []);

  // Adicionar ou editar URL
  const handleSave = async (formData) => {
    setModalLoading(true);
    if (editUrl) {
      // Editar
      const { error } = await supabase.from('permitted_urls').update({ url: formData.url, description: formData.description }).eq('id', editUrl.id);
      if (error) alert('Erro ao editar: ' + error.message);
    } else {
      // Adicionar
      const { error } = await supabase.from('permitted_urls').insert([{ url: formData.url, description: formData.description }]);
      if (error) alert('Erro ao adicionar: ' + error.message);
    }
    setModalLoading(false);
    setModalOpen(false);
    setEditUrl(null);
    await fetchUrls();
  };

  // Excluir URL
  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir esta URL?')) return;
    const { error } = await supabase.from('permitted_urls').delete().eq('id', id);
    if (error) alert('Erro ao excluir: ' + error.message);
    await fetchUrls();
  };

  return (
    <div className="proxy-page-container">
      <div className="section-container">
        <div className="main-header">
          <h2>Gerenciamento de URLs Permitidas</h2>
          <button onClick={() => { setEditUrl(null); setModalOpen(true); }} className="add-button">
            <span>Adicionar URL</span>
          </button>
        </div>
        <div className="content-area">
          {loading ? (
            <p className="loading-text">Carregando...</p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>URL</th>
                  <th>Descrição</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {urls.length > 0 ? urls.map(urlObj => (
                  <tr key={urlObj.id}>
                    <td data-label="URL">{urlObj.url}</td>
                    <td data-label="Descrição">{urlObj.description || '-'}</td>
                    <td data-label="Ações" className="actions-cell">
                      <button className="action-button edit" onClick={() => { setEditUrl(urlObj); setModalOpen(true); }}>Editar</button>
                      <button className="action-button delete" onClick={() => handleDelete(urlObj.id)}>Excluir</button>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan="3" className="empty-table-message">Nenhuma URL cadastrada.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <ModalUrl
        isOpen={isModalOpen}
        onClose={() => { setModalOpen(false); setEditUrl(null); }}
        onSave={handleSave}
        initialData={editUrl}
        loading={modalLoading}
      />
    </div>
  );
}

export default AllowedUrls;
